import React, { useState, useEffect } from 'react';
import SupplyChainContract from '../../contracts/SupplyChainContract'; 
import tickImage from '../../img/tick.png'
import crossImage from '../../img/cross.png';

const DistributorPage = () => {
  const [batchIdForUpdate, setBatchIdForUpdate] = useState('');
  const [searchedBatchId, setSearchedBatchId] = useState('');
  const [acceptance, setAcceptance] = useState(false);
  const [remarkEnabled, setRemarkEnabled] = useState(false);
  const [remark, setRemark] = useState('');
  const [distributorVCs, setDistributorVCs] = useState([]);
  const [farmerVCs, setFarmerVCs] = useState([]);
  const [inspectorVCs, setInspectorVCs] = useState([]);
  const [searchedDistributorVC, setSearchedDistributorVC] = useState(null);
  const [farmerDataForUpdate, setFarmerDataForUpdate] = useState(null);
  const [inspectorDataForUpdate, setInspectorDataForUpdate] = useState(null);
  const [searchInputDistributor, setSearchInputDistributor] = useState('');


  useEffect(() => {
    handleFetchAllDistributorVCs();
    handleFetchAllFarmerVCs();
    handleFetchAllInspectorVCs();
  }, []); 

  const handleUpdateDistributorVC = async () => {
    try {
      const batchId = parseInt(batchIdForUpdate);

      if (isNaN(batchId)) {
        console.error('Invalid BatchID. Please enter a valid number.');
        return;
      }

      const farmerVC = await SupplyChainContract.methods.getFarmerVCByBatchId(batchId).call();
      const inspectorVC = await SupplyChainContract.methods.getInspectorVCByBatchId(batchId).call();

      setFarmerDataForUpdate(farmerVC);
      setInspectorDataForUpdate(inspectorVC);

      await SupplyChainContract.methods
        .updateDistributorVC(batchId, acceptance, remark)
        .send({ from: window.ethereum.selectedAddress }); 
      alert('DistributorVC updated successfully!');
      
      handleFetchAllDistributorVCs();
    } catch (error) {
      console.error('Error updating DistributorVC:', error);
    }
  };

  const handleFetchAllDistributorVCs = async () => {
    try {
      const totalDistributorVCs = await SupplyChainContract.methods.getTotalDistributorVCs().call();
  
      const distributorVCList = [];
      for (let i = 1; i <= totalDistributorVCs; i++) {
        const distributorVC = await SupplyChainContract.methods.getDistributorVCByBatchId(i).call();
        
        if (distributorVC.batchID !== '0') {
          distributorVCList.push(distributorVC);
        }
      }
  
      setDistributorVCs(distributorVCList);
    } catch (error) {
      console.error('Error fetching all DistributorVCs:', error);
    }
  };
  
  const handleSearchByBatchIdDistributor = async () => {
    try {
      const batchId = parseInt(searchedBatchId);
  
      if (isNaN(batchId)) {
        console.error('Invalid BatchID. Please enter a valid number.');
        return;
      }
  
      const distributorVC = await SupplyChainContract.methods.getDistributorVCByBatchId(batchId).call();
  
      if (distributorVC.batchID !== 0) {
        setSearchedDistributorVC(distributorVC);
        setSearchInputDistributor(searchedBatchId);
      } else {
        setSearchedDistributorVC(null);
        console.log('No DistributorVC found with the specified BatchID.');
      }
    } catch (error) {
      console.error('Error fetching DistributorVC:', error);
    }
  };

  const convertEpochToTime = (epochTime) => {
    const date = new Date(epochTime * 1000); 
    return date.toLocaleString(); 
  };

  const handleFetchAllFarmerVCs = async () => {
    try {
      const totalFarmerVCs = await SupplyChainContract.methods.getTotalFarmerVCs().call();
      const farmerVCList = [];
      for (let i = 1; i <= totalFarmerVCs; i++) {
        const farmerVC = await SupplyChainContract.methods.getFarmerVCByBatchId(i).call();
        farmerVCList.push(farmerVC);
      }
      setFarmerVCs(farmerVCList);
    } catch (error) {
      console.error('Error fetching all FarmerVCs:', error);
    }
  };

  const handleFetchAllInspectorVCs = async () => {
    try {
      const totalInspectorVCs = await SupplyChainContract.methods.getTotalInspectorVCs().call();
      const inspectorVCList = [];
      for (let i = 1; i <= totalInspectorVCs; i++) {
        const inspectorVC = await SupplyChainContract.methods.getInspectorVCByBatchId(i).call();
        inspectorVCList.push(inspectorVC);
      }
      setInspectorVCs(inspectorVCList);
    } catch (error) {
      console.error('Error fetching all InspectorVCs:', error);
    }
  };

  const handleBatchIdChange = async (batchId) => {
    try {
      if (isNaN(batchId)) {
        console.error('Invalid BatchID. Please enter a valid number.');
        return;
      }

      const farmerVC = await SupplyChainContract.methods.getFarmerVCByBatchId(batchId).call();
      const inspectorVC = await SupplyChainContract.methods.getInspectorVCByBatchId(batchId).call();

      setFarmerDataForUpdate(farmerVC);
      setInspectorDataForUpdate(inspectorVC);
    } catch (error) {
      console.error('Error fetching FarmerVC and InspectorVC data:', error);
    }
  };

  return (
    <div className="container mx-auto p-8 pt-16">
      <div className="flex justify-between">

      {/* Update DistributorVC Form */}
      <div className="w-1/2 pr-4 mb-8">
        <h3 className="text-2xl font-semibold mb-4">Update Distributor Verifiable Credential</h3>
        <div className="flex items-center mb-4">
          <label className="mr-4">BatchID:</label>
          <input
            type="text"
            value={batchIdForUpdate}
            onChange={(e) => {
              setBatchIdForUpdate(e.target.value);
              handleBatchIdChange(e.target.value);
            }}
            className="border p-2"
          />
        </div>

      {/* Danger Alert for Danger Check or Inspector Check */}
      {inspectorDataForUpdate && (!inspectorDataForUpdate.inspectorCheck || inspectorDataForUpdate.dangerCheck) && (
        <div className="mt-4 p-3 bg-red-200 border border-red-400 text-red-800 rounded mb-5">
          <strong>Alert! DO NOT ACCEPT IF:</strong>
          <div className="flex items-center">
            {!inspectorDataForUpdate.inspectorCheck && (
              <>
                <span className="mr-2">Inspector Check is</span>
                <img src={crossImage} alt="cross" style={{ width: '24px', height: '24px' }} />
              </>
            )}
            {(!inspectorDataForUpdate.inspectorCheck && inspectorDataForUpdate.dangerCheck) && <span className="mx-2">or</span>}
            {inspectorDataForUpdate.dangerCheck && (
              <>
                <span className="mr-2">Danger Check is</span>
                <img src={tickImage} alt="tick" style={{ width: '24px', height: '24px' }} />
              </>
            )}
          </div>
        </div>
      )}

      <div className="flex items-center mb-4">
        <label className="mr-4">Acceptance:</label>
        <select
          value={acceptance}
          onChange={(e) => setAcceptance(e.target.value === 'true')}
          className="border p-2"
        >
          <option value={true}>Yes</option>
          <option value={false}>No</option>
        </select>
      </div>
      <div className="flex items-center mb-4">
        <label className="mr-4">Remark:</label>
        <input
          type="checkbox"
          checked={remarkEnabled}
          onChange={() => setRemarkEnabled(!remarkEnabled)}
          className="mr-2 h-6 w-6"
        />
        {remarkEnabled && (
          <input
            type="text"
            value={remark}
            onChange={(e) => setRemark(e.target.value)}
            className="border p-2"
          />
        )}
      </div>
      <button onClick={handleUpdateDistributorVC} className="bg-blue-500 text-white px-4 py-2 rounded">
        Update DistributorVC
      </button>
    </div>

    {/* Display FarmerVC and InspectorVC data (below the DistributorVC section) */}
    {farmerDataForUpdate && (
      <div className="w-1/2 pl-4">
        <div className="border p-2 rounded-md">
        <h5 className="text-lg font-semibold mb-2">Meat Processor VC Data | BatchID {batchIdForUpdate}</h5>
          <div className="flex justify-between">
            <div className="text-left">
              <p>Quantity:</p>
              <p>Grading Results:</p>
              <p>Date of Production:</p>
              <p>Country of Origin:</p>
              <p>Expiry Date:</p>
            </div>
            <div className="text-right">
              <p>{farmerDataForUpdate.quantity}</p>
              <p>{farmerDataForUpdate.gradingResults}</p>
              <p>{farmerDataForUpdate.countryOfOrigin}</p>
              <p>{convertEpochToTime(farmerDataForUpdate.dateOfProduction)}</p>
              <p>{convertEpochToTime(farmerDataForUpdate.expiryDate)}</p>
            </div>
          </div>
        </div>
      </div>
    )}

    {inspectorDataForUpdate && (
      <div className="w-1/2 pl-4">
        <div className="border p-2 rounded-md">
          <h5 className="text-lg font-semibold mb-2">Inspector VC Data | BatchID {batchIdForUpdate}</h5>
          <div className="flex justify-between">
            <div className="text-left">
              <p>Inspector Check:</p>
              <p>Danger Check:</p>
              <p>Remark:</p>
              <p>Update Timestamp:</p>
            </div>
            <div className="text-right">
              <p style={{ paddingRight: '160px' }}>
                {inspectorDataForUpdate.inspectorCheck ? (
                  <img src={tickImage} alt="tick" style={{ width: '24px', height: '24px' }} />
                ) : (
                  <img src={crossImage} alt="cross" style={{ width: '24px', height: '24px' }} />
                )}
              </p>
              <p style={{ paddingRight: '160px' }}>
                {inspectorDataForUpdate.dangerCheck ? (
                  <img src={tickImage} alt="tick" style={{ width: '24px', height: '24px' }} />
                ) : (
                  <img src={crossImage} alt="cross" style={{ width: '24px', height: '24px' }} />
                )}
              </p>
              <p>{inspectorDataForUpdate.remark || 'No Remark'}</p>
              <p style={{ minWidth: '150px' }}>{convertEpochToTime(inspectorDataForUpdate.timestamp)}</p>
            </div>
          </div>
        </div>
      </div>
    )}

    </div>


    <h3 className="text-2xl font-semibold mb-4">Search DistributorVC</h3>
      {/* Search by BatchID Form */}
      <div className="mb-8 flex items-center"> 
        <div className="mr-4 flex items-center"> 
          <label className="mr-4">BatchID:</label>
          <input
            type="text"
            value={searchedBatchId}
            onChange={(e) => setSearchedBatchId(e.target.value)}
            className="border p-2"
          />
        </div>
        <button onClick={handleSearchByBatchIdDistributor} className="bg-blue-500 text-white px-4 py-2 rounded">Search</button>
      </div>

      {/* Display searched DistributorVC data */}
      {searchedDistributorVC && (
        <div className="mb-8">
          <h3 className="text-2xl font-semibold mb-4">Search Result</h3>
          <p>BatchID: {searchedDistributorVC.batchID}</p>
          <p>Timestamp: {convertEpochToTime(searchedDistributorVC.timestamp)}</p>
          <p>Acceptance: {searchedDistributorVC.acceptance ? 'Yes' : 'No'}</p>
          <p>Remark: {searchedDistributorVC.remark}</p>
        </div>
      )}


      <div className="container mx-auto">
        {/* Display all Data in a combined table */}
        <div className="mt-8">
          <div className="flex justify-between items-center mb-4">
            <h3 className="text-2xl font-semibold">Verifiable Credentials List</h3>

            {/* Search input for DistributorVCs (placed on the right) */}
            <div className="flex items-center">
              <label className="mr-4 text-lg">Search:</label>
              <input
                type="text"
                value={searchInputDistributor}
                onChange={(e) => setSearchInputDistributor(e.target.value)}
                onKeyPress={(e) => {
                  if (e.key === 'Enter') {
                    handleSearchByBatchIdDistributor();
                  }
                }}
                className="border p-2"
              />
            </div>
          </div>

          <table className="w-full border">
            <thead>
              <tr className="bg-gray-200">
                <th className="border p-2 text-center" rowSpan="2">
                  BatchID
                </th>
                <th className="border p-2 text-center" colSpan="5" style={{ backgroundColor: '#6EE7B7' }}>
                  Meat Processor
                </th>
                <th className="border p-2 text-center" colSpan="4" style={{ backgroundColor: '#63B3ED' }}>
                  Inspector
                </th>
                <th className="border p-2 text-center" colSpan="3" style={{ backgroundColor: '#FFD700' }}>
                  Distributor
                </th>
              </tr>
              <tr className="bg-gray-200">
                {/* Headers for FarmerVC */}
                <th className="border p-2 text-center bg-green-200">Quantity</th>
                <th className="border p-2 text-center bg-green-200">Grading Results</th>
                <th className="border p-2 text-center bg-green-200">Country of Origin</th>
                <th className="border p-2 text-center bg-green-200">Date of Production</th>
                <th className="border p-2 text-center bg-green-200">Expiry Date</th>
                {/* Headers for InspectorVC */}
                <th className="border p-2 text-center bg-blue-200">Inspector Check</th>
                <th className="border p-2 text-center bg-blue-200">Danger Check</th>
                <th className="border p-2 text-center bg-blue-200">Remark</th>
                <th className="border p-2 text-center bg-blue-200">Update Timestamp</th>
                {/* Headers for DistributorVC */}
                <th className="border p-2 text-center bg-yellow-200">Acceptance</th>
                <th className="border p-2 text-center bg-yellow-200">Remark</th>
                <th className="border p-2 text-center bg-yellow-200">Update Timestamp</th>
              </tr>
            </thead>
            <tbody>
              {distributorVCs
                .filter((distributorVC) =>
                  String(distributorVC.batchID).toLowerCase().includes(searchInputDistributor.toLowerCase()) ||
                  String(distributorVC.acceptance).toLowerCase().includes(searchInputDistributor.toLowerCase()) ||
                  String(distributorVC.remark).toLowerCase().includes(searchInputDistributor.toLowerCase())
                )
                .map((distributorVC, index) => (
                  <tr key={`distributorVC_${index}_${distributorVC.batchID}`} className={distributorVC.batchID % 2 === 0 ? 'bg-gray-100' : ''}>
                    <td className="border p-2 text-center">{distributorVC.batchID}</td>
                    {/* FarmerVC Data */}
                    <td className={`border p-2 text-center bg-green-200`}>{farmerVCs[index] ? farmerVCs[index].quantity : '-'}</td>
                    <td className={`border p-2 text-center bg-green-200`}>{farmerVCs[index] ? farmerVCs[index].gradingResults : '-'}</td>
                    <td className={`border p-2 text-center bg-green-200`}>{farmerVCs[index] ? farmerVCs[index].countryOfOrigin : '-'}</td>
                    <td className={`border p-2 text-center bg-green-200`}>
                      {farmerVCs[index] ? convertEpochToTime(farmerVCs[index].dateOfProduction) : '-'}
                    </td>
                    <td className={`border p-2 text-center bg-green-200`}>
                      {farmerVCs[index] ? convertEpochToTime(farmerVCs[index].expiryDate) : '-'}
                    </td>
                    {/* InspectorVC Data */}
                    <td className={`border p-2 text-center bg-blue-200 ${inspectorVCs[index]?.inspectorCheck === false ? 'bg-red-200' : ''}`}>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        {inspectorVCs[index]?.inspectorCheck ? (
                          <img src={tickImage} alt="tick" style={{ width: '20px', height: '20px' }} />
                        ) : (
                          <img src={crossImage} alt="cross" style={{ width: '20px', height: '20px' }} />
                        )}
                      </div>
                    </td>
                    <td className={`border p-2 text-center bg-blue-200 ${inspectorVCs[index]?.dangerCheck === false ? 'bg-red-200' : ''}`}>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        {inspectorVCs[index]?.dangerCheck ? (
                          <img src={tickImage} alt="tick" style={{ width: '20px', height: '20px' }} />
                        ) : (
                          <img src={crossImage} alt="cross" style={{ width: '20px', height: '20px' }} />
                        )}
                      </div>
                    </td>
                    <td className={`border p-2 text-center bg-blue-200`}>{inspectorVCs[index]?.remark}</td>
                    <td className={`border p-2 text-center bg-blue-200`}>{convertEpochToTime(inspectorVCs[index]?.timestamp)}</td>

                    {/* DistributorVC Data */}
                    <td className={`border p-2 text-center bg-yellow-200`}>{distributorVC.acceptance ? 'Yes' : 'No'}</td>
                    <td className={`border p-2 text-center bg-yellow-200`}>{distributorVC.remark}</td>
                    <td className={`border p-2 text-center bg-yellow-200`}>{convertEpochToTime(distributorVC.timestamp)}</td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default DistributorPage;